// Pure helpers for the QA Priority Queue modal (components/QAPriorityQueue.js). Backend: /qa-priority.

// The columns, in order: the program row field, its header, the Lead QA Review tab it opens (null = the
// program's general view, where the pending-delivery banner to accept and review incoming leads lives).
export const QUEUE_COLUMNS = [
  { key: 'pending_review', label: 'Pending Review', status: 'Pending Review', tab: null },
  { key: 'under_review', label: 'Under Review', status: 'Under Review', tab: 'Under Review' },
  { key: 'approved_pending_call_review', label: 'Approved Pending Call Review', status: 'Approved Pending Call Review', tab: 'Approved Pending Call Review' },
  { key: 'demandarc_accepted', label: 'DemandArc Accepted', status: 'DemandArc Accepted', tab: 'DemandArc Accepted' },
];

// Who may reorder the queue (the backend enforces it too): Admin and Program Managers, supporting PMs included.
export const canOverrideQueue = (role) => ['admin', 'program_manager', 'supporting_program_manager'].includes(role);

// Where a count click goes: a program id plus the Lead QA Review status tab ('all' = the program's general view).
export function jumpTarget(program, column) {
  const col = QUEUE_COLUMNS.find(c => c.key === column);
  return { programId: program.program_id, status: (col && col.tab) || 'all' };
}

// The program ids in a new order after moving one up or down a place; null when it is already at that end.
export function movedOrder(programs, programId, direction) {
  const ids = programs.map(p => p.program_id);
  const i = ids.indexOf(programId);
  const j = direction === 'up' ? i - 1 : i + 1;
  if (i < 0 || j < 0 || j >= ids.length) return null;
  [ids[i], ids[j]] = [ids[j], ids[i]];
  return ids;
}

// Backend timestamps are UTC without a Z (see the main CLAUDE.md gotcha), so add it before parsing.
export function formatSetAt(iso) {
  if (!iso) return '';
  const d = new Date(/Z$|[+-]\d\d:\d\d$/.test(iso) ? iso : `${iso}Z`);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

// "resets_on" is the Monday the next week starts; the override ends with the Sunday before it.
export function endOfWeekLabel(resetsOn) {
  if (!resetsOn) return 'the end of the week';
  const d = new Date(`${resetsOn}T12:00:00`);
  d.setDate(d.getDate() - 1);
  return d.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
}
